/**
 * Route for enum and set custom fields — opens an option list with explanatory text.
 */
import { Stack, useLocalSearchParams } from "expo-router";
import { useTranslation } from "react-i18next";

import { FieldSelectionScreen, useProfileForm } from "@/features/profile";

function parseFieldCode(value: string | string[] | undefined): string | null {
    const raw = Array.isArray(value) ? value[0] : value;
    return raw?.trim() ? raw : null;
}

export default function FieldSelectionRoute() {
    const { t } = useTranslation();
    const { fieldCode: fieldCodeParam } = useLocalSearchParams<{
        fieldCode: string;
    }>();
    const fieldCode = parseFieldCode(fieldCodeParam);
    const { person } = useProfileForm();
    const field = fieldCode ? person.custom_fields[fieldCode] : undefined;

    return (
        <>
            <Stack.Screen
                options={{
                    title: field?.field_name ?? t("screens.selectOption"),
                }}
            />
            {fieldCode ? <FieldSelectionScreen fieldCode={fieldCode} /> : null}
        </>
    );
}
